import { DisplayNameSchema } from "../../../valibot/schema/DisplayName.type"
import { array, number, object, type InferOutput } from "valibot"
import { ActionBindingSchema } from "../ActionBinding.type"

export const InputProfileSchema = object({
  id: number(),
  dname: DisplayNameSchema,
  updated_at: number(),
  actionBindings: array(ActionBindingSchema),
})

export type InputProfile = InferOutput<typeof InputProfileSchema>

export const InputProfilePresetSchema = object({
  preset: number(), // StorageKind.Preset
  presetId: number(), // InputProfilePresetId
  actionBindings: array(ActionBindingSchema),
})

export type InputProfilePreset = InferOutput<typeof InputProfilePresetSchema>

